import * as tslib_1 from "tslib";
import { DatePipe } from '@angular/common';
import { Directive, EmbeddedViewRef, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
let DateDirective = class DateDirective {
    constructor(viewContainer, templateRef, datePipe) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.datePipe = datePipe;
        // tslint:disable-next-line:no-input-rename
        this.editable = true;
    }
    ngOnChanges(changes) {
        if (changes['field'] || changes['format']) {
            if (!this.viewRef) {
                this.viewContainer.clear();
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
            }
            this.updateView();
        }
    }
    updateView() {
        const field = this.field;
        if (!field || (!field.editable && !field.value)) {
            return;
        }
        const html = field.editable && this.editable ? field.editable : field.value;
        const setDangerously = field.editable && this.editable;
        this.viewRef.rootNodes.forEach((node) => {
            if (setDangerously) {
                node.innerHTML = html;
            }
            else {
                node.textContent = this.datePipe.transform(html, this.format, this.timezone, this.locale);
            }
        });
    }
};
DateDirective.ɵfac = function DateDirective_Factory(t) { return new (t || DateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DatePipe)); };
DateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DateDirective, selectors: [["", "scDate", ""]], inputs: { editable: ["scDateEditable", "editable"], format: ["scDateFormat", "format"], timezone: ["scDateTimezone", "timezone"], locale: ["scDateLocale", "locale"], field: ["scDate", "field"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DateDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: DatePipe }
];
tslib_1.__decorate([
    Input('scDateFormat')
], DateDirective.prototype, "format", void 0);
tslib_1.__decorate([
    Input('scDateTimezone')
], DateDirective.prototype, "timezone", void 0);
tslib_1.__decorate([
    Input('scDateLocale')
], DateDirective.prototype, "locale", void 0);
tslib_1.__decorate([
    Input('scDateEditable')
], DateDirective.prototype, "editable", void 0);
tslib_1.__decorate([
    Input('scDate')
], DateDirective.prototype, "field", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateDirective, [{
        type: Directive,
        args: [{
                selector: '[scDate]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc1.DatePipe }]; }, { editable: [{
            type: Input,
            args: ['scDateEditable']
        }], format: [{
            type: Input,
            args: ['scDateFormat']
        }], timezone: [{
            type: Input,
            args: ['scDateTimezone']
        }], locale: [{
            type: Input,
            args: ['scDateLocale']
        }], field: [{
            type: Input,
            args: ['scDate']
        }] }); })();
export { DateDirective };
